import { render, staticRenderFns } from "./ProdutosPaginasRevista.vue?vue&type=template&id=6fa5d195"
import script from "./ProdutosPaginasRevista.vue?vue&type=script&lang=ts"
export * from "./ProdutosPaginasRevista.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports